import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import TeamSubteamsNavbar from 'team/components/subteams/TeamSubteamsNavbar';
import TeamSubteamsSearchBar from 'team/components/subteams/TeamSubteamsSearchBar';
import TeamSubteamsTable from 'team/components/subteams/TeamSubteamsTable';
import TeamSubteamsEmptyState from 'team/components/subteams/TeamSubteamsEmptyState';
import TeamAddSubteamModal from 'team/components/subteams/TeamAddSubteamModal';
import { useSubteams } from 'team/hooks/useSubteams';

const TeamSubteamsContainer = ({ user, team }) => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedSubteamIds, setSelectedSubteamIds] = useState([]);
    const [isAddSubteamModalOpen, setIsAddSubteamModalOpen] = useState(false);

    // Fetch and filter subteams
    const { subteams, filteredSubteams, loading, fetchSubteams, setSubteams } = useSubteams(searchQuery);
    const subteamsCount = subteams.length;
    const hasSubteams = filteredSubteams.length > 0;

    const handleAddSubteamSelect = () => {
        setIsAddSubteamModalOpen(true);
    };

    const handleCreateSubteamClick = () => {
        setIsAddSubteamModalOpen(true);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSubteamClick = (subteam) => {
        if (subteam && subteam._id) {
            navigate(`/team/subteams/${subteam._id}/members`);
        }
    };

    const handleSelectSubteams = (selectedIds) => {
        setSelectedSubteamIds(selectedIds);
    };

    return (
        <Box sx={{ width: '100%', padding: 2 }}>
            <TeamSubteamsNavbar
                subteamsCount={subteamsCount}
                onAddSubteamSelect={handleAddSubteamSelect}
            />

            <TeamSubteamsSearchBar
                value={searchQuery}
                onChange={handleSearchChange}
            />

            {hasSubteams ? (
                <TeamSubteamsTable
                    subteams={filteredSubteams}
                    onSubteamClick={handleSubteamClick}
                    onSelectSubteams={handleSelectSubteams}
                    selectedSubteamIds={selectedSubteamIds}
                    onSubteamRemoved={fetchSubteams}
                />
            ) : (
                <TeamSubteamsEmptyState onCreateSubteam={handleCreateSubteamClick} />
            )}

            <TeamAddSubteamModal
                open={isAddSubteamModalOpen}
                onClose={() => setIsAddSubteamModalOpen(false)}
                onSuccess={async (createdSubteam) => {
                    // Optimistically add the subteam to the list immediately
                    if (createdSubteam && createdSubteam._id) {
                        setSubteams(prevSubteams => {
                            // Check if subteam already exists to avoid duplicates
                            const exists = prevSubteams.some(st => st._id === createdSubteam._id);
                            if (exists) {
                                return prevSubteams;
                            }
                            return [...prevSubteams, createdSubteam];
                        });
                    }

                    // Close modal
                    setIsAddSubteamModalOpen(false);

                    // Then refresh from server to ensure consistency
                    await fetchSubteams();
                }}
            />
        </Box>
    );
};

export default TeamSubteamsContainer;
